var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6380",
    x: 14.001,
    y: 14,
    width: 26.969,
    height: 28.928,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(-459 -253)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(459 253)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 459, 253)",
    filter: "url(#Path_6380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6380-2",
    "data-name": "Path 6380",
    d: "M4620.9-977.812a2.877,2.877,0,0,1-1.281,2.3,26.437,26.437,0,0,1-2.3,1.4q-5.473,3.063-10.96,6.1c-.538.3-1.085.583-1.643.844a2.884,2.884,0,0,1-1.52.287,2.342,2.342,0,0,1-2.038-1.774,6.975,6.975,0,0,1-.193-1.971c-.023-3.733-.022-7.467-.027-11.2,0-1.1-.008-2.2.015-3.307a6.414,6.414,0,0,1,.2-1.863,2.314,2.314,0,0,1,1.992-1.78,3.014,3.014,0,0,1,1.811.4c1.544.829,3.087,1.658,4.617,2.511q4.591,2.559,9.166,5.145a4.625,4.625,0,0,1,1.588,1.284A2.94,2.94,0,0,1,4620.9-977.812Z",
    transform: "translate(-4583.43 1005.29)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.00c03e46c9f1fa235d0a0f9eabda4d6e.svg";
export { ForwardRef as ReactComponent };